import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { SecurityDtoKeysEnum } from '@zaoblako/shared/modules/security/enums/security-dto-keys.enum';
import { SecurityBackendValidatorsEnum } from '@zaoblako/shared/modules/security/enums/security-backend-validators.enum';
import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';

import * as yup from 'yup';

/** New profile register API request body */
export interface ProfileRegisterInterface {
  /** Profile email (login) */
  email: string;
  /** Profile full name last, first and middle names (or at least one of them) */
  name: string;
}

/** New profile register API request body - DTO schema */
export const ProfileRegisterDto = SerdeDtoClass.create<ProfileRegisterInterface>(SecurityDtoKeysEnum.PROFILE_REGISTER_DTO, {
  email: {
    label: 'Email',
    checkers: [SecurityBackendValidatorsEnum.PROFILE_EMAIL_UNIQUE],
    serializer: yup
      .string()
      .email(DtoMessageEnum.INCORRECT_EMAIL),
  },
  name: {
    label: 'ФИО',
    serializer: yup
      .string()
      .min(1, DtoMessageEnum.EMPTY_STRING),
  },
});
